import { FC, useEffect } from 'react';
import { Img } from '@/components/blocks/MaterialImage';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { Box, Dialog, IconButton } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { useDpHidden } from '../DpHiddenForDay';

export const DpPopUpPromotion: FC<{ src: string; alt?: string }> = ({
	src,
	alt = 'Dp promotion',
}) => {
	const openDrawerSizeGuide = useIsOpen();

	useEffect(() => {
		openDrawerSizeGuide.on();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const hidden = useDpHidden();
	const isMobile = useIsMobile();
	if (isMobile) return null;
	if (!hidden) return null;
	return (
		<Dialog open={openDrawerSizeGuide.open} onClose={openDrawerSizeGuide.off}>
			<Box sx={{ position: 'relative' }}>
				<IconButton
					color="inherit"
					onClick={openDrawerSizeGuide.off}
					sx={{
						position: 'absolute',
						right: '15px',
						top: '15px',
						'&:hover': {
							backgroundColor: 'transparent',
							color: 'inherit',
						},
					}}
				>
					<ClearIcon sx={{ color: 'white' }} fontSize="inherit" />
				</IconButton>
			</Box>
			<Img sx={{ width: '400px', height: '400px' }} src={src} alt={alt} />
		</Dialog>
	);
};
